import { usePeriod, useReport } from './useReport';
import { Panel, PeriodFilter, QueryState, FundBreakdown, ReportTable } from './ReportComponents';
import { money } from './periods';
export function TreasureReports() {
  const [period,setPeriod] = usePeriod();
  const report = useReport(period);
  return <><PeriodFilter value={period} onChange={setPeriod}/><Panel title="Net recorded giving by fund" description="Contribution dates in the selected period. Refunds and reversals reduce the net; this is not a gross-contribution total or accounting reconciliation.">
    <QueryState pending={report.isPending} error={report.isError} empty={!!report.data&&!report.data.funds.length} onRetry={()=>void report.refetch()}/>
    {report.data && <><div className="treasure-report-total"><span>Selected-period net</span><strong>{money(report.data.net,report.data.currency)}</strong></div><FundBreakdown report={report.data}/><ReportTable report={report.data}/></>}
  </Panel></>;
}
